import CalendarModuleNewEventButton from '../components/CalendarModuleNewEventButton';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import * as React from 'react';

export function getNewEventItem() {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: 'newEvent',
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.onRender]: () => <CalendarModuleNewEventButton />,
    });
}
